export const Loading = () => {
    return (
        <div style={{width:"100%", height: window.innerHeight, background:"url('/images/loading.png') center center no-repeat"}}></div>
    )
}
